<template>
  <div>
    <p class="text-static-default-mid body-2 md:pl-40">
      {{ i18n(translations.sectionTitle) }}
    </p>

    <div
      class="flex overflow-x-auto scrollbar-none gap-8 my-16 -mx-24 px-24 py-4 md:px-40 md:mx-0"
    >
      <RecentlyViewedLink
        v-for="link in recentlyViewedSearchesAndPlps"
        :key="link.id"
        :to="link.url"
        :underlined="false"
        :entryType="link.entryType"
        :title="link.title"
        @click="closeSearchBar"
      />
    </div>

    <ProductFeed
      v-if="recentlyViewedPdps.length > 0"
      :products="recentlyViewedPdps"
      @click-product="closeSearchBar"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { RecentlyViewedPage } from '../../composables/useRecentlyViewedPages/useRecentlyViewedPages.types'
import { useToggleSearchBar } from '../../composables/useToggleSearchBar'
import ProductFeed from '../ProductFeed/ProductFeed.vue'

import translations from './RecentlyViewedSection.translations'
import RecentlyViewedLink from './components/RecentlyViewedLink/RecentlyViewedLink.vue'

const i18n = useI18n()
const { closeSearchBar } = useToggleSearchBar()

const props = defineProps<{ recentlyViewedPages: RecentlyViewedPage[] }>()

const recentlyViewedSearchesAndPlps = computed(() =>
  props.recentlyViewedPages.filter(
    (page) => page.entryType === 'plp' || page.entryType === 'search-query',
  ),
)

const recentlyViewedPdps = computed(() =>
  props.recentlyViewedPages.filter((page) => page.entryType === 'pdp'),
)
</script>
